import * as React from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Stack from "@mui/material/Stack";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  adminMenuItems,
  customerMenuItems,
  secondaryListItemsDashboard,
} from "../../../data/dashboard/menu";

export default function MenuContent() {
  const auth = useSelector((state) => state.user);
  const [mainListItems, setMainListItems] = React.useState([]);
  const [secondaryListItems, setSecondaryListItems] = React.useState([]);

  React.useEffect(() => {
    if (["ADMIN", "EMPLOYEE"].includes(auth?.user?.role)) {
      setMainListItems(adminMenuItems);
    } else {
      setMainListItems(customerMenuItems);
    }
    setSecondaryListItems(secondaryListItemsDashboard);
  }, [auth.user.role]);

  const location = useLocation(); // Get current route

  return (
    <Stack sx={{ flexGrow: 1, p: 1, justifyContent: "space-between" }}>
      <List dense>
        {mainListItems.map((item, index) => (
          <ListItem key={index} disablePadding sx={{ display: "block" }}>
            <Link to={item.to}>
              <ListItemButton selected={location.pathname === item.to}>
                <ListItemIcon>{item.icon}</ListItemIcon>
                <ListItemText primary={item.text} />
              </ListItemButton>
            </Link>
          </ListItem>
        ))}
      </List>
      <List dense>
        {secondaryListItems.map((item, index) => (
          <ListItem key={index} disablePadding sx={{ display: "block" }}>
            <ListItemButton>
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Stack>
  );
}
